import React from "react";
import { FiInfo } from "react-icons/fi";

export const FANPAGE_INFO_TOOLTIP_TEXT =
  "Bật khi bạn đăng cho 1 fanpage và muốn AI viết sát hơn với tên, thương hiệu và lĩnh vực của fanpage đó. Khi chọn nhiều fanpage, tùy chọn này sẽ tự ẩn để bài viết phù hợp chung cho tất cả.";

export const CONTACT_INFO_TOOLTIP_TEXT =
  "Bật khi bạn muốn bài đăng có phần liên hệ ở cuối bài, như số điện thoại, địa chỉ hoặc link đặt hàng. Khi hệ thống tự đăng, phần liên hệ đã lưu của fanpage sẽ được thêm nếu bài chưa có sẵn để tránh lặp.";

export const WEBSITE_CONTACT_INFO_FIELD_TOOLTIP_TEXT =
  "Nhập thông tin liên hệ bạn muốn tự động chèn vào cuối bài viết WordPress: số điện thoại, link Zalo, địa chỉ, hotline, link đặt hàng... Mỗi website chỉ cấu hình một lần, có thể xuống dòng tự do, có thể dùng emoji (📞 📍 🛒 💬) để phân tách rõ từng mục. Khi tạo bài, bạn chỉ cần bật toggle Thêm thông tin liên hệ là nội dung này sẽ được tự động thêm vào cuối bài.";

export const WEBSITE_INFO_TOOLTIP_TEXT =
  "Nhập mô tả ngắn về website (lĩnh vực hoạt động, đối tượng độc giả, tông giọng mong muốn...). AI sẽ sử dụng thông tin này làm ngữ cảnh để viết các bài đăng phù hợp nhất với định hướng của website.";

export const WEBSITE_CONTACT_TOGGLE_TOOLTIP_TEXT =
  "Bật khi bạn muốn tự động chèn thông tin liên hệ đã lưu của website vào cuối bài viết WordPress. Hệ thống sẽ chèn bằng code (không qua AI) để đảm bảo chính xác, và sẽ bỏ qua nếu bài viết đã có sẵn phần liên hệ để tránh trùng lặp.";

const SettingTooltip = ({ label, text }) => (
  <button
    type="button"
    className="group relative inline-flex h-4 w-4 items-center justify-center rounded-full text-gray-400 outline-none transition-colors hover:text-blue-500 focus-visible:text-blue-500"
    aria-label={`Giải thích: ${label}`}
  >
    <FiInfo className="h-3.5 w-3.5" />
    <span className="pointer-events-none invisible absolute left-1/2 top-full z-50 mt-2 w-80 max-w-[calc(100vw-3rem)] -translate-x-1/2 rounded-lg bg-slate-800 px-3 py-2 text-left text-xs font-medium leading-relaxed text-white opacity-0 shadow-xl transition-opacity group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 group-focus-visible:visible group-focus-visible:opacity-100">
      {text}
      <span className="absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent border-b-slate-800" />
    </span>
  </button>
);

export default SettingTooltip;
